// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuContainer__i6oPb {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  grid-template-rows: 40px 1fr;
  border: 1px solid var(--dark-blue);
  z-index: 4;
  background-color: white;
  border-radius: 10px;
}

.header__wXWX4 {
  grid-column: 1/-1;
  padding: 8px;
  box-sizing: border-box;
  height: 40px;
  border-radius: 8px 8px 0 0;
  border: none;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: var(--dark-blue);
  align-items: center;
}

.itemsColumn__A4ms5 {
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 4px;
  grid-auto-rows: min-content;
  overflow-y: auto;
  padding-bottom: 10px;
}

.itemButton__bBoxS {
  display: flex;
  padding: 6px 7px;
  align-items: center;
  justify-content: start;
  cursor: pointer;
}

.itemButton__bBoxS.selected__ToWI2 {
  background-color: var(--background-light-blue);
}

.itemButton__bBoxS:hover {
  display: flex;
  align-items: center;
  justify-content: start;
}

.detailsColumn__cg7M6 {
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: min-content;
  grid-row-gap: 6px;
  border-left: 1px solid var(--dark-blue);
  padding-bottom: 10px;
}

.detailsHeader__MCzA5 {
  display: flex;
  border-bottom: 1px solid var(--dark-blue);
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: center;
  padding: 6px;
}

@media (hover: hover) {
  .itemButton__bBoxS:hover {
    background-color: var(--light-background-grey);
  }
  .itemButton__bBoxS.selected__ToWI2:hover {
    background-color: var(--background-light-blue);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/flow-component/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,kCAAkC;EAClC,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;AACF","sourcesContent":[".menuContainer {\n  display: grid;\n  grid-template-columns: 1.1fr 1fr;\n  grid-template-rows: 40px 1fr;\n  border: 1px solid var(--dark-blue);\n  z-index: 4;\n  background-color: white;\n  border-radius: 10px;\n}\n\n.header {\n  grid-column: 1/-1;\n  padding: 8px;\n  box-sizing: border-box;\n  height: 40px;\n  border-radius: 8px 8px 0 0;\n  border: none;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: var(--dark-blue);\n  align-items: center;\n}\n\n.itemsColumn {\n  display: grid;\n  grid-template-columns: 1fr;\n  margin-top: 4px;\n  grid-auto-rows: min-content;\n  overflow-y: auto;\n  padding-bottom: 10px;\n}\n\n.itemButton {\n  display: flex;\n  padding: 6px 7px;\n  align-items: center;\n  justify-content: start;\n  cursor: pointer;\n}\n\n.itemButton.selected {\n  background-color: var(--background-light-blue);\n}\n\n.itemButton:hover {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n\n.detailsColumn {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-auto-rows: min-content;\n  grid-row-gap: 6px;\n  border-left: 1px solid var(--dark-blue);\n  padding-bottom: 10px;\n}\n\n.detailsHeader {\n  display: flex;\n  border-bottom: 1px solid var(--dark-blue);\n  box-sizing: border-box;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 6px;\n}\n\n@media (hover: hover) {\n  .itemButton:hover {\n    background-color: var(--light-background-grey);\n  }\n  .itemButton.selected:hover {\n    background-color: var(--background-light-blue);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `menuContainer__i6oPb`,
	"header": `header__wXWX4`,
	"itemsColumn": `itemsColumn__A4ms5`,
	"itemButton": `itemButton__bBoxS`,
	"selected": `selected__ToWI2`,
	"detailsColumn": `detailsColumn__cg7M6`,
	"detailsHeader": `detailsHeader__MCzA5`
};
export default ___CSS_LOADER_EXPORT___;
